export default __webpack_public_path__ + "static/Background-40e5a09a8e3332ddf53cd66220811256.webp";